// removed by extract-text-webpack-plugin
module.exports = {"container":"src-pages----testimonials-module---container---3ILd-","quote":"src-pages----testimonials-module---quote---18vDU"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/testimonials.module.scss
// module id = 941
// module chunks = 88173770026806